import { apiWithoutAuth, type ApiResponse } from '@/shared';

import { globalMarketPaths } from './paths';

import type { GlobalMarketIndicesResponse, GlobalMarketCommoditiesResponse } from '../types';

export const getIndices = async () => {
  const { data } = await apiWithoutAuth.get<ApiResponse<GlobalMarketIndicesResponse>>(
    globalMarketPaths.indices,
  );
  return data.result;
};

export const getCommodities = async () => {
  const { data } = await apiWithoutAuth.get<ApiResponse<GlobalMarketCommoditiesResponse>>(
    globalMarketPaths.commodities,
  );
  return data.result;
};
